import { jwtDecode } from "jwt-decode";
// import { handleError } from "../Utils";

export const getEmail = () => {
  const token = localStorage.getItem("token");
  if (token) {
    const decoded = jwtDecode(token);
    return decoded.email;
  }
  // return handleError("Token not found"); // Return null if no token is found
};

export const getRole = () => {
  const token = localStorage.getItem("token");
  if (token) {
    const decoded = jwtDecode(token);
    return decoded.role;
  }
};

//
export const authUser = () => {
  const token = localStorage.getItem("token");
  if (token) {
    const decoded = jwtDecode(token);
    return decoded;
  }
};